import ClearIcon from '@mui/icons-material/Clear'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Fade from '@mui/material/Fade'
import * as React from 'react'
import MessageAttachment from './message-attachment'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade direction="up" ref={ref} {...props} />
})

function ChatMessageImageDialog({ url, title, isOpen, handleCloseDialog }) {
  return (<Dialog
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleCloseDialog}
      aria-describedby="chat-message-image-dialog" >
      <DialogTitle>
        {title}
        <ClearIcon onClick={handleCloseDialog}  style={{ float: 'right', cursor : 'pointer'}}/> 
      </DialogTitle>
      <DialogContent className="chat-message-image-dialog">
        <MessageAttachment
          src={url}
          alt={`${title}.png`} />
      </DialogContent>
  </Dialog>)
}

export default React.memo(ChatMessageImageDialog)